import { HeaderType } from '@design-system/components/templates/header/entities/header.types';

export enum HeaderPageType {
  HomePage = 'HomePage',
  LandingPage = 'LandingPage',
  SearchPage = 'SearchPage',
  ResultsPage = 'ResultsPage',
  ResultDetailPage = 'ResultDetailPage',
  MyTripsPage = 'MyTripsPage',
  PriceAlertPage = 'PriceAlertPage',
  TripDetailPage = 'TripDetailPage',
  LastTripDetailPage = 'LastTripDetailPage',
  TripDetailCancellationPage = 'TripDetailCancellationPage',
  SeatMapPage = 'SeatMapPage',
  BookingPage = 'BookingPage',
  CheckoutPage = 'CheckoutPage',
  InfoPage = 'InfoPage',
}

export enum AnimatedHeaderState {
  Init = 'init',
  Open = 'open',
  Closed = 'closed',
}

export enum HeaderProductType {
  Air = 'Air',
  Hotels = 'Hotels',
  Cars = 'Cars',
  Packages = 'Packages',
  ByHours = 'ByHours',
  Exchanges = 'Exchanges',
  Activities = 'Activities',
}

export interface DsHeaderConfig {
  type: HeaderType | null;
  titleKey: string | null;
  pageType: HeaderPageType | null;
  productType?: HeaderProductType;
  animatedType?: HeaderType;
  titleIcon?: string;
}
